<template>
  <div class="page-container">
    <!-- Content Wrapper START -->
    <div class="main-content">
      <pageheader :page-name="pageName" parent-page-name="Presentation Materials" parent-page-url="/presentation-materials" />
      <add-edit-form
        v-if="model"
        returnUrl="/presentation-materials"
        :apiBaseUrl="API_BASE_URL"
        :model="model"
        :fields="fields"
        :toEdit="toEdit"
      />
    </div>
    <!-- Content Wrapper END -->
  </div>
</template>

<script>
import Pageheader from '@/components/Pageheader.vue'
import AddEditForm from '@/components/AddEditForm.vue'
import Presentation from '@/models/Presentation'
/* eslint-disable no-undef */
export default {
  name: 'AddPresentation',
  components: {
    Pageheader,
    AddEditForm
  },
  computed: {
    toEdit () {
      return this.$route.params.id !== undefined
    },
    pageName () {
      return this.toEdit ? 'Edit Presentation' : 'Add Presentation'
    }
  },
  data () {
    return {
      API_BASE_URL: 'presentation',
      model: null,
      fields: [
        { label: 'Name', key: 'name', type: 'text' },
        { label: 'Sort number', key: 'sort_no', type: 'number' },
        { label: 'Powerpoint Format', key: 'powerpoint', type: 'format' },
        { label: 'EPS Format', key: 'EPS', type: 'format' },
        { label: 'PSD Format', key: 'PSD', type: 'format' },
        { label: 'PDF Format', key: 'PDF', type: 'format' },
        { label: 'PNG Format', key: 'PNG', type: 'format' },
        { label: 'Word Format', key: 'WORD_DOC', type: 'format' },
        { label: 'JPG Format', key: 'JPG', type: 'format' },
        { label: 'All Formats', key: 'ALL', type: 'format' },
        { label: 'AI Format', key: 'AI', type: 'format' }
      ]
    }
  },
  mounted () {
    if (this.toEdit) {
      this.fetch()
    } else {
      this.model = new Presentation()
    }
  },
  methods: {
    fetch () {
      this.$store.dispatch(this.API_BASE_URL + '/get', this.$route.params.id)
        .then((result) => {
          this.model = new Presentation(result.presentation)
        })
        .catch((err) => this.$helper.catchHandler(err))
      return null
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Presentations/AddEdit.vue